import React, { Component, Fragment } from 'react';
import { Row, Button } from 'reactstrap';
import ReactTable from 'react-table';
import Select from 'react-select';
import { Colxx } from '../../../../components/common/CustomBootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import DataTablePagination from '../../../../components/DatatablePagination';
import { Card, CardBody, CardTitle } from 'reactstrap';
import IntlMessages from '../../../../helpers/IntlMessages';
import {
  reactSelectOptionDiffrentPro, sortPropertyListByName
} from '../../../../helpers/Utils';
import {
  getUserList,
  getRoleList,
  getPropertyList,
} from '../../../../redux/actions';
import {
  gAPI_Users_list,
  gAPI_Internal_Property_By_Id,
  postAPI_TrackEvent,
  gAPI_Internal_Property_List,
  gAPI_Search_Users_list,
  gAPI_Users_By_Id,
  gAPI_GetUsersAuditLogs_list
} from '../../../../constants/APIs';
import { AxiosAPI, getGroupID, getUserID } from '../../../../helpers/AxiosAPI';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CreateInviteUsersForm from './components/forms/CreateInviteUsersForm';
import UpdateUsersForm from './components/forms/UpdateUsersForm';
import ReinviteUserForm from './components/forms/ReinviteUserForm';
import GenerateInvitationLink from './components/forms/GenerateInvitationLink';
import GenerateResetPasswordLink from './components/forms/GenerateResetPasswordLink';
import ContactsForm from './components/forms/ContactsForm';
import AuditLogsList from './components/forms/AuditLogsList';
const dataTableColumns = [
  {
    Header: 'Name',
    accessor: 'fullName',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Email',
    accessor: 'email',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: (props) => <p className="">{props.value}</p>,
  },
  {
    Header: 'Role',
    accessor: 'roles',
    Cell: (props) => (
      <p className="">
        {props.value.map((role, index) => {
          return (
            <Fragment key={index}>
              {role === 'User' ? 'Knowledge Manager' : role}
              {<br />}
            </Fragment>
          );
        })}
      </p>
    ),
  },
  {
    Header: '',
    accessor: 'userId',
    Cell: (props) => <UpdateUsersForm id={props.value} />,
  },
  {
    Header: '',
    accessor: 'email',
    Cell: (props) => (
      <p className="">
        {props.row.status !== 'Pending' ? (
          <GenerateResetPasswordLink email={props.value} id={props.row.userId} />
        ) : null}
      </p>
    ),
  },
  {
    Header: '',
    accessor: 'userId',
    Cell: (props) => (
      <p className="">
        {props.row.status === 'Pending' ? (
          <ReinviteUserForm id={props.value} />
        ) : null}
      </p>
    ),
  },
  {
    Header: '',
    accessor: 'userId',
    Cell: (props) => (
      <p className="">
        {props.row.status === 'Pending' ? (
          <GenerateInvitationLink id={props.value} />
        ) : null}
      </p>
    ),
  },
];
const statusList = [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
  { label: "Pending", value: "Pending" },
  { label: "Deleted", value: "Deleted" },
];

const roleList = [
  // { label: "SuperAdmin", value: "1" },
  { label: "Admin", value: "2" },
  { label: "Knowledge Manager", value: "3" },
  // { label: "BillingAdmin", value: "4" },
  { label: "Agent", value: "5" },
  // { label: "PII", value: "6" },
  // { label: "View", value: "7" },
];

class AdminPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      isLoading: true,
      contacts: null,
      editContact: false,
      name: '',
      propertyList: [],
      selectedProperty: [],
      // selectedStatus: [],
      selectedStatus: [
        { label: "Active", value: "Active" },
        { label: "Pending", value: "Pending" }
      ],
      selectedRoles: [],
      isFiltering: false,
      isLogs: false
    };
  }

  componentDidMount() {
    // this.props.getUserList();
    if (this.props.email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'Dashboard Users and Admin',
          email: this.props.email,
        },
      }).then(
        (res) => { },
        (error) => {
          console.log(error);
        }
      );
    }
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Search_Users_list}/${getGroupID()
        }?pid=${this.state.selectedProperty.length > 0 ? this.state.selectedProperty.map((a) => a.value).join('|') : "-1"
        }&status=${this.state.selectedStatus.length > 0 ? this.state.selectedStatus.map((a) => a.value).join('|') : "-1"
        }&roles=${this.state.selectedRoles.length > 0 ? this.state.selectedRoles.map((a) => a.value).join('|') : "-1"}`,
    }).then(
      (res) => {
        this.setState((state) => ({
          data: res.data,
          isLoading: false,
        }));
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    })
      .then((res) => {
        var userproperties = res.data.properties;
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Internal_Property_List}?group_id=${getGroupID()}`,
        })
          .then((res) => {
            const finalResult = [];
            if (userproperties.length > 0 && userproperties[0] === "-1") {
              res.data.forEach((p) => {
                finalResult.push(p);
              });
            } else {
              res.data.forEach((p) => {
                userproperties.forEach((r) => {
                  if (p.id === r) {
                    finalResult.push(p);
                  }
                });
              });
            }
            this.setState({ propertyList: finalResult, isLoading: false });
          })
          .catch((err) => console.log('err', err));
        if (this.props.propertyId !== '-1') {
          AxiosAPI({
            method: 'get',
            url: `${gAPI_Internal_Property_By_Id}/${this.props.propertyId
              }?group_id=${getGroupID()}`,
          })
            .then((res) => {
              this.setState({ contacts: res.data.contacts, name: res.data.name });
            })
            .catch((err) => console.error(err));
        }
      });
    // this.props.getRoleList();
    // this.props.getPropertyList();
  }

  handleChangeSelect = (value, { name }) => {
    if (name === "property") {
      this.setState({ selectedProperty: value });
    }
    else if (name === "roles") {
      this.setState({ selectedRoles: value });
    }
    else if (name === "status") {
      this.setState({ selectedStatus: value });
    }
  }
  handleSubmitClick = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Search_Users_list}/${getGroupID()
        }?pid=${this.state.selectedProperty.length > 0 ? this.state.selectedProperty.map((a) => a.value).join('|') : "-1"
        }&status=${this.state.selectedStatus.length > 0 ? this.state.selectedStatus.map((a) => a.value).join('|') : "-1"
        }&roles=${this.state.selectedRoles.length > 0 ? this.state.selectedRoles.map((a) => a.value).join('|') : "-1"}`,
    }).then(
      (res) => {
        this.setState((state) => ({
          data: res.data,
          isLoading: false,
          isFiltering: false,
        }));
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  }
  render() {
    return (
      <Fragment>
        <div className="mb-2">
          <Row>
            <div className=" d-inline-block  mt-2">
              <Button
                size="xs"
                color="primary"
                className=""
                onClick={() => this.setState({ isFiltering: !this.state.isFiltering })}
              >
                <div className='d-flex'>
                  <FontAwesomeIcon icon={faFilter} className="fa mr-1 mt-1" />
                  <IntlMessages id="menu.show-filter" />
                  <div className='ml-1' style={{ marginTop: "2px" }}>
                    {this.state.isFiltering ?
                      <i className='simple-icon-arrow-up p-1'></i> :
                      <i className='simple-icon-arrow-down p-1'></i>
                    }
                  </div>
                </div>
              </Button>
            </div>
            {this.props.propertyId !== '-1' && (

              <div className="d-block d-md-inline-block mt-2 ml-2">
                <Button
                  color="primary"
                  outline
                  size="xs"
                  onClick={() => this.setState({ editContact: true })}
                  className="top-right-button mr-1"
                // style={{ width: '100%', borderRadius: '6px' }}
                >
                  + Subscribe to Tickets & Emails
                </Button>

                {this.state.editContact && (
                  <ContactsForm
                    contacts={this.state.contacts}
                    id={this.props.propertyId}
                    name={this.state.name}
                    visible={this.state.editContact}
                    toggle={() =>
                      this.setState({
                        editContact: !this.state.editContact,
                      })
                    }
                  />
                )}
              </div>
            )}

            <div className="mb-2 d-inline-block ml-2 mt-2">
              <CreateInviteUsersForm />
            </div>

            <div className="mb-2 d-inline-block ml-2 mt-2">
              <Button
                color="primary"
                outline
                size="xs"
                onClick={() => this.setState({ isLogs: true })}
                className="top-right-button mr-1"
              // style={{ width: '100%', borderRadius: '6px' }}
              >
                Logs
              </Button>
            </div>
          </Row>
        </div>
        <Colxx xxs="12" className="mb-2 text-right">
          <strong><hr /></strong>
        </Colxx>
        {this.state.isFiltering && (
          <Card className="filter-width mt-2" style={{ position: "absolute", zIndex: "1", top: "7rem", marginLeft: "0rem", boxShadow: "0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)" }}>
            <CardBody >

              <Colxx md="12" >
                <Row>
                  <Colxx xxs="12" md="12" className="mb-2">
                    <Select
                      isMulti={true}
                      // components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      name="property"
                      placeholder="Property"
                      onChange={this.handleChangeSelect}
                      options={
                        this.state.propertyList && this.state.propertyList.length > 0
                          ? reactSelectOptionDiffrentPro(
                            sortPropertyListByName(this.state.propertyList),
                            true,
                            'id',
                            'name',
                            'All Properties'
                          )
                          : []
                      }
                      value={this.state.selectedProperty}
                    />
                  </Colxx>
                  <Colxx xxs="12" md="12" className=" mb-2">
                    <Select
                      isMulti={true}
                      // components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      name="status"
                      placeholder="Status"
                      onChange={this.handleChangeSelect}
                      options={
                        statusList
                          ? reactSelectOptionDiffrentPro(
                            statusList,
                            true,
                            'value',
                            'label',
                            'Select Status'
                          )
                          : []
                      }
                      value={this.state.selectedStatus}
                    />
                  </Colxx>
                  <Colxx xxs="12" md="12" className="mb-2">
                    <Select
                      isMulti={true}
                      // components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      name="roles"
                      placeholder="Roles"
                      onChange={this.handleChangeSelect}
                      options={
                        roleList
                          ? reactSelectOptionDiffrentPro(
                            roleList,
                            true,
                            'value',
                            'label',
                            'Roles'
                          )
                          : []
                      }
                      value={this.state.selectedRoles}
                    />
                  </Colxx>
                  <Colxx xxs="12" md="12" >
                    <Button size={"xs"}
                      color="primary"
                      className="mb-2 mt-2"
                      onClick={() => this.handleSubmitClick()}>
                      Search
                    </Button>
                    <Button
                      size="xs"
                      color="secondary"
                      className="mb-2 ml-2 mt-2"
                      onClick={() => this.setState({ isFiltering: false })}
                    >
                      Cancel
                    </Button>

                  </Colxx>
                </Row>
              </Colxx>
            </CardBody>
          </Card>
        )}
        <Colxx xxs="12" className="mb-2">
          <Fragment>

            <Card className="mb-2">
              <CardBody>
                {!this.state.isLoading && this.state.data ? (
                  <ReactTable
                    data={this.state.data}
                    columns={dataTableColumns}
                    defaultPageSize={10}
                    filterable={false}
                    showPageJump={true}
                    PaginationComponent={DataTablePagination}
                    showPageSizeOptions={true}
                    defaultSorted={[
                      {
                        id: 'email',
                        desc: false,
                      },
                    ]}
                  />
                ) : (
                  <div className="loading" />
                )}
              </CardBody>
            </Card>
          </Fragment>
        </Colxx>

        {/* <Colxx xxs="4" className="mb-2">
            <CardTitle>Permissions</CardTitle>
            <Card className="mb-2">
              <CardBody>
                {loading1 ? (
                  <Fragment>
                    <div className="d-flex ticket-info-requester-title">
                      Roles
        </div>
                    {roles.map((role, index) => {
                      return (
                        <CustomInput
                          key={index}
                          type="checkbox"
                          id="exCustomInline"
                          label={role.name}
                        />
                      );
                    })}
                  </Fragment>
                ) : (
                    <div className="loading" />
                  )}
                {loading2 ? (
                  <Fragment>
                    <div className="d-flex ticket-info-requester-title">
                      Properties
        </div>
                    {properties.map((property, index) => {
                      return (
                        <CustomInput
                          key={index}
                          type="checkbox"
                          id="exCustomInline"
                          label={property.name}
                        />
                      );
                    })}
                  </Fragment>
                ) : (
                    <div className="loading" />
                  )}
              </CardBody>
            </Card>
          </Colxx> */}
        {this.state.isLogs &&
          <AuditLogsList logType={"UsersRoles"} visible={this.state.isLogs} toggle={() => this.setState({ isLogs: false })}></AuditLogsList>}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ usersListApp, settings }) => {
  const { propertyId, email } = settings;
  return {
    usersListApp,
    propertyId,
    email,
  };
};
export default injectIntl(
  connect(mapStateToProps, {
    getUserList,
    getRoleList,
    getPropertyList,
  })(AdminPage)
);
